import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PageRoutes } from '../../constants/routes';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../auth/AuthContext';
import { LocalStorageKeys } from '../../constants/locationStorage';

export const AppleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { getProfileAndRedirect } = useApp();
  const { exchangeGoogleApple } = useAuth();
  const returnTo = searchParams.get('returnTo');

  useEffect(() => {
    if (returnTo) {
      localStorage.setItem(LocalStorageKeys.POST_LOGIN_REDIRECT, returnTo);
      return;
    }

    localStorage.removeItem(LocalStorageKeys.POST_LOGIN_REDIRECT);
  }, [returnTo]);

  useEffect(() => {
    const handleAppleCallback = async () => {
      console.log('Apple callback received');
      console.log('Current URL:', window.location.href);
      console.log('Search params:', Object.fromEntries(searchParams.entries()));

      // Check for authorization code or ID token
      const code = searchParams.get('code');
      const idToken = searchParams.get('id_token');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      if (error) {
        console.error('Apple Sign In error:', error);
        navigate(PageRoutes.LOGIN);
        return;
      }

      if (idToken) {
        console.log('Apple ID token received in callback:', idToken);
        try {
          const session = await exchangeGoogleApple(idToken, 'apple');
          localStorage.setItem(LocalStorageKeys.IS_AUTHENTICATED, 'true');

          if (!session.profileConfirmed) {
            navigate(PageRoutes.ONBOARDING_BEST_DESCRIBES);
            return;
          }

          await getProfileAndRedirect(session.accessToken, returnTo);
        } catch (error) {
          console.error('Apple authentication failed:', error);
          navigate(PageRoutes.LOGIN);
        }
      } else if (code) {
        console.log('Apple authorization code received:', code);
        // Handle authorization code flow if your backend expects it
        // For now, redirect to login since we expect ID token
        navigate(PageRoutes.LOGIN);
      } else {
        console.log('No token or code received, redirecting to login');
        navigate(PageRoutes.LOGIN);
      }
    };

    handleAppleCallback();
  }, [navigate, searchParams, exchangeGoogleApple, getProfileAndRedirect]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Processing Apple Sign In...</h2>
      <p>Please wait while we complete your sign in.</p>
    </div>
  );
};
